'use strict';

remitRegisterModule.factory('remitRegisterService', 
['AppSettings', 'imSessionVarsService', 'erateSessionVarsService',
'commonRESTCallService', '$q','searchUrlFactory','QuoteSearchResult',
function (AppSettings, imSessionVarsService, erateSessionVarsService,
          commonRESTCallService, $q, searchUrlFactory, QuoteSearchResult) {

    var remitRegisterApi = {};
    var remitRegisterUrl = AppSettings.startSPANPlusSvcURL + 'remitregister';
    var providerId = imSessionVarsService.getCurrentProviderId();
    var dealerId = erateSessionVarsService.getCurrentDealerSPANId();


    remitRegisterApi.searchContracts = function(startDate, endDate, firstName, lastName, vin, contractNumber,contractsOnly, endIndex, pageSize, status, format){
        var promiseWrapper = $q.defer();
        if (endIndex == 'undefined')
            endIndex=0;

        var parameters = {
            dealerId : erateSessionVarsService.getCurrentDealerSPANId(),
            paging : {
                num : endIndex,
                size : pageSize,
                sortBy : 'quoteDate',
                sortOrder : 'desc'
            },
            filters : {
                fromDate : startDate,
                toDate : endDate,
                firstName: firstName,
                lastName: lastName,
                vin: vin,
                contractNumber: contractNumber,
                contractStatus : status, // We are bringing all the statuses, as we can choose which ones we want to see on the UI
                contractsOnly: contractsOnly,
                format: format,
            }
        };

        var searchUrl = searchUrlFactory.buildComboSearchUrl(parameters);
        if (format == 'excel')
        {
            promiseWrapper.resolve({url : searchUrl});
        }
        else {
            commonRESTCallService.getFromServer(searchUrl)
                .success(function (responseData, status) {
                    var results = transformSearchResults(responseData, contractsOnly);

                    promiseWrapper.resolve({records: results, totalNumRecs: responseData.totalRowCount});
                });
        }

        return promiseWrapper.promise;
    }

    function transformSearchResults(responseData, contractsOnly) {
        var items = responseData.itemList || responseData;

            var results = items.map(function (element) {
                var quoteResult = new QuoteSearchResult();
                quoteResult.populateDataFromTLCAPI(element);

                return quoteResult;
            });
        return results;
    }

    remitRegisterApi.finalizeContracts = function(finalContractIds) {
        var promiseWrapper = $q.defer();

        var postUrl = AppSettings.startSPANPlusSvcURL + 'productcontractsremit/finalize';
        var postBody = {
            contractIds : finalContractIds,
            providerName : imSessionVarsService.getCurrentProviderCode()
        };

        commonRESTCallService.postToServer(postUrl, postBody)
            .then(
                function gotResult(res){
                    promiseWrapper.resolve(true);
                },
                function errResult(err){
                    throw err;
                }
            );
        return promiseWrapper.promise;
    };

            

    remitRegisterApi.getRemittancePeriods = function() {
        var urlGet = remitRegisterUrl + "/spandealerid/" + dealerId;
        return commonRESTCallService.getFromServer(urlGet);
    };

    remitRegisterApi.createRemittancePeriod = function() {
        var promiseWrapper = $q.defer();

        var urlGetProv = AppSettings.startSPANPlusSvcURL + 'spanproviders/name/' + imSessionVarsService.getCurrentProviderCode();

        commonRESTCallService.getFromServer(
            urlGetProv
        )
        .then(
            function(providers){
                var provid = providers.data.itemList[0].providerId;

                var urlPost = remitRegisterUrl + "/providerid/" + provid + "/spandealerid/" + dealerId;

                commonRESTCallService.postToServer(urlPost)
                .then(
                    function(response){
                        promiseWrapper.resolve(response);
                    }
                )
            }
        );

        return promiseWrapper.promise;
    };


    function constructRemitSheetUrl(remitRegisterId) {
        var urlGet = remitRegisterUrl + "/" + remitRegisterId;
        return urlGet;
    }

    //get a page of a remit sheet
    remitRegisterApi.getRemitSheet = function (remitRegisterId) {
        var registerContractsUrl = AppSettings.startSPANPlusSvcURL + 'productcontractsremit/list/' +
            imSessionVarsService.getCurrentProviderCode() + '/' + dealerId + '/' + remitRegisterId;

        //var url = constructRemitSheetUrl(remitRegisterId);
        
        return commonRESTCallService.getFromServer(registerContractsUrl);
    };

    remitRegisterApi.constructRemitSheetExportUrl = function (remitRegisterId) {
        var promiseWrapper = $q.defer();
        // This method does not actually obtain any data from the API.  It simply creates a url that may be used to request an xml
        // representation of a given remit register, suitable for use in a window.open call
        var remitSheetExportUrl = constructRemitSheetUrl(remitRegisterId)
        remitSheetExportUrl = remitSheetExportUrl + "?format=excel";
       commonRESTCallService.getFromServer(remitSheetExportUrl)
           .success(function(responseData, status) {
               promiseWrapper.resolve(responseData);
           });

        return promiseWrapper.promise;
    };

    //remove a contract from the register
    remitRegisterApi.deleteContractFromRegister = function (contractId, remitRegisterId) {
        var urlPost = AppSettings.startSPANPlusSvcURL + 'productcontractsremit/remove';
        return commonRESTCallService.postToServer(urlPost,
            {
                contractIds : [contractId],
                providerName : imSessionVarsService.getCurrentProviderCode(),
                remitRegisterId : remitRegisterId
            }
        );
    };

    remitRegisterApi.closeRemitSheet = function(remitRegisterId, currentRegister){
      var urlPut = AppSettings.startSPANPlusSvcURL + 'productcontractsremit/close-register/'
        + imSessionVarsService.getCurrentProviderCode() + '/' + dealerId + '/' + remitRegisterId;
        
        return commonRESTCallService.putToServer(urlPut, {});
    };

    // voiding contracts (ARCHIVE status change)
    remitRegisterApi.voidContractsMulti = function(finalContractIds, voidStatusId) {
        var promiseWrapper = $q.defer();

        var httpPromises = [];
        for (var i=0; i < finalContractIds.length; i = i+1){
            var postUrl = AppSettings.showcaseGWApi + 'productcontracts/' + finalContractIds[i] + '/changestatus';
            var postBody = {
                statusid : voidStatusId,
                requestinguser : imSessionVarsService.getCurrentIMUser().UserName
            };
            httpPromises.push(
                commonRESTCallService.postToServer(postUrl, postBody)
            );
        }

        $q.all(httpPromises)
        .then(
            function(httpResponses){
                promiseWrapper.resolve("Success");
            },
            function(httpError){
                promiseWrapper.reject(httpError && _.isArray(httpError) ? httpError[0].data.Message : httpError.data.Message);
            }
        )
        return promiseWrapper.promise;
    };
    // get the contract void (archive) status
    remitRegisterApi.getProviderContractVoidStatus = function(){
        var promiseWrapper = $q.defer();

        var urlGetProv = AppSettings.startSPANPlusSvcURL + 'spanproviders/name/' + imSessionVarsService.getCurrentProviderCode();

        commonRESTCallService.getFromServer(
            urlGetProv
        )
        .then(
            function(providers){
                var provid = providers.data.itemList[0].providerId;

                var urlGetStatus = AppSettings.startSPANPlusSvcURL + 'contractstatuses/spanprovider/' + provid + '/statusname/VOID';

                commonRESTCallService.getFromServer(urlGetStatus)
                .then(
                    function response(res){
                        var item = res.data.itemList[0];
                        promiseWrapper.resolve(item);
                    }
                )
            }
        )

        return promiseWrapper.promise;

    };

    return remitRegisterApi;
}]);
